export default __webpack_public_path__ + "static/media/arrow-down-white.9f375088.svg";